import $http from '../../utils/http'

// HALYK_QR_ROLLOUT_GATE: кэшируем только успешное чтение Remote Config - пока RC
// не активировался, getString отдаёт '' и парс падает; повторный заход перечитает
let featureConfigPromise = null

const halykQr = {
  namespaced: true,

  state: {
    // HALYK_QR_ROLLOUT_GATE: null = конфиг не получен (fail-closed)
    allowedBusinessIds: null,
  },

  getters: {
    // HALYK_QR_ROLLOUT_GATE: точки входа Единого QR видны только организациям
    // из HALYK_QR_CONFIG.businessIds ('*' = всем); подключённые кассы гейт обходят
    // через halykQRAvailable в qrPaymentMixin
    featureEnabled(state, getters, rootState) {
      const organization = rootState.cashRegisters.cashRegister && rootState.cashRegisters.cashRegister.organization
      return Array.isArray(state.allowedBusinessIds) && !!organization
        && (state.allowedBusinessIds.includes('*') || state.allowedBusinessIds.includes(organization.businessId))
    },
  },

  mutations: {
    set(state, { type, value }) {
      state[type] = value
    },
  },

  actions: {
    // HALYK_QR_ROLLOUT_GATE: HALYK_QR_CONFIG = {"businessIds": ["123456789012", ...]}
    fetchFeatureConfig({ commit, dispatch }) {
      if (featureConfigPromise) {
        return featureConfigPromise
      }
      featureConfigPromise = dispatch('tools/firebaseRemoteConfigGetString', 'HALYK_QR_CONFIG', { root: true })
        .then((result) => {
          const config = JSON.parse(result)
          if (!Array.isArray(config.businessIds)) {
            throw new Error('HALYK_QR_CONFIG.businessIds is not an array')
          }
          commit('set', { type: 'allowedBusinessIds', value: config.businessIds })
        })
        .catch(() => {
          featureConfigPromise = null
        })
      return featureConfigPromise
    },

    listTerminals({}, payload) {
      return $http.get(`/halyk-qr/api/terminals/${payload.bin}/list`)
    },

    connectTerminal({}, payload) {
      return $http.post('/halyk-qr/api/terminals/connect', payload)
    },

    disconnectTerminal({}, payload) {
      return $http.post('/halyk-qr/api/terminals/disconnect', payload)
    },

    generateDynamicQr({}, payload) {
      return $http.post('/halyk-qr/api/qr/dynamic', payload)
    },

    getQrStatus({}, payload) {
      return $http.get(`/halyk-qr/api/qr/status/${payload.billNumber}`)
    },

    // Погасить неоплаченный QR (только из статусов NEW/SCANNED).
    // reason (TIMEOUT | CLOSE) бэкенд пишет в БД для аналитики, в банк не уходит
    rejectQr({}, payload) {
      return $http.post(`/halyk-qr/api/qr/${payload.billNumber}/reject`, { reason: payload.reason })
    },

    refundInit({}, payload) {
      return $http.post('/halyk-qr/api/qr/refund/init', payload)
    },

    getRefundStatus({}, payload) {
      return $http.get(`/halyk-qr/api/qr/refund/${payload.refundId}/status`)
    },

    confirmRefund({}, payload) {
      return $http.post(`/halyk-qr/api/qr/refund/${payload.refundId}/confirm`)
    },

  },
}

export default halykQr
